import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AttendanceComponent } from './attendance.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path: 'attendance', component: AttendanceComponent}
    ])
  ],
  declarations:[],
  exports: [RouterModule]
})

export class AttendanceRoutingModule { }
